module.exports = __webpack_public_path__ + "static/media/fit.6f137bae.png";